// Destination.jsx
import React from "react";
import "./Style.css";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Rating,
  Container,
} from "@mui/material";

// Destination Data
// const destinations = [
//   {
//     name: "Siaconset Beach",
//     category: "Beach",
//     country: "Island",
//     rating: 4.9,
//     image: "img/Hero1.webp",
//   },
//   {
//     name: "Horseshoe Bay",
//     category: "Beach",
//     country: "Indonesia",
//     rating: 4.9,
//     image: "img/Hero2.webp",
//   },
//   {
//     name: "Virgin Gorda",
//     category: "Beach",
//     country: "Japan",
//     rating: 4.9,
//     image: "img/Hero3.webp",
//   },
// ];

function Destination() {
  return (
    <Box className="destination-container" id="Destinations">
      <Container maxWidth="lg">
        <Typography variant="h4" className="destination-heading">
          Explore Destinations
        </Typography>
        <p>
          With <b>TNG Global</b>, you’re not just booking a trip, you’re embarking on a thoughtfully crafted journey designed with passion, expertise, and meticulous attention to every detail. From the very first moment you share your travel dreams with us, until the time you return home with cherished memories, our dedicated team ensures that every aspect of your trip is seamless, personalized, and stress-free. We handle the planning, logistics, and special touches so you can fully immerse yourself in exploring new destinations, embracing unique experiences, and creating unforgettable moments that will stay with you for a lifetime.
        </p>

        {/* <Grid container spacing={3} justifyContent="center">
          {destinations.map(function (destination, index) {
            return (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card className="destination-card">
                  <CardMedia
                    component="img"
                    height="200"
                    image={destination.image}
                    alt={destination.name}
                  />
                  <CardContent>
                    <Typography variant="h6" className="destination-card-title">
                      {destination.name}
                    </Typography>
                    <Typography
                      variant="body2"
                      className="destination-card-subtitle"
                    >
                      {destination.country}
                    </Typography>
                    <Rating
                      value={destination.rating}
                      precision={0.1}
                      readOnly
                      className="destination-rating"
                    />
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid> */}
      </Container>
    </Box>
  );
}

export default Destination;
